import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SiteStatusLogsService } from '../../../core/api/site-status-logs.service';
import { Site } from '../../../shared/models';
import { SiteStatusLog } from '../../../shared/models/site-status-log';

@Component({
  selector: 'fc-site-status-log',
  templateUrl: './site-status-log.component.html',
  styleUrls: ['./site-status-log.component.scss'],
})
export class SiteStatusLogComponent implements OnInit {
  logs: SiteStatusLog[] = null;
  displayedColumns: string[] = ['oldStatus', 'status', 'changedBy', 'changeDate'];
  logSubscription: Subscription;

  @Input() site: Site;
  @Input() isAdmin = false;

  constructor(private logService: SiteStatusLogsService) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  loadLogs(): void {
    this.logService.getSiteLogs(this.site.id).subscribe((logs: SiteStatusLog[]) => (this.logs = logs));
  }
}
